export interface BaseExceptionContext {
  service?: 'api' | 'postalcode-lookup-api';
  entity?: string;
  request?: {
    url?: string;
    method?: string;
    body?: unknown;
    query?: string;
    headers?: Record<string, string>;
    startTime?: string;
  };
  response?: {
    statusCode?: number;
    headers?: Record<string, string>;
    response?: unknown;
    endTime?: string;
    durationMs?: number;
    durationSec?: number;
  };
  [key: string]: unknown; // allow extending
}

export class BaseException<
  TContext extends BaseExceptionContext = BaseExceptionContext,
> extends Error {
  public readonly context: TContext;

  constructor(message: string, context: TContext) {
    super(message);
    this.name = this.constructor.name;
    this.context = context;
  }
}
